<template>
  <v-dialog
    v-if="cartDrawer"
    max-width="500"
    :value="dialog"
    @click:outside="$store.commit('orders/CLOSE_MINIMUM_ORDER_AMOUNT_DIALOG')"
  >
    <v-card class="py-10 px-7">
      <CloseDialogButton
        :close="() => $store.commit('orders/CLOSE_MINIMUM_ORDER_AMOUNT_DIALOG')"
      />
      <v-row no-gutters>
        <v-col class="d-flex justify-center">
          <!--
          <v-icon
            class="mdi-card-account-details-outline"
          >mdi-card-account-details-outline</v-icon>
          -->
          <div
            class="color-fire-engine-red font-size-lg font-weight-semibold mb-8"
          >
            Below Order Minimum
          </div>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col class="font-size-lg mb-12 text-center">
          Order {{ formatCurrency(wait(storeInfo, "min_order_amount")) }} or
          more to proceed with checkout
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col class="text-center">
          <v-btn
            color="primary"
            height="48"
            width="180"
            rounded
            @click.stop="
              $store.commit('orders/CLOSE_MINIMUM_ORDER_AMOUNT_DIALOG')
            "
          >
            <div class="font-size-md">ok</div>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import { formatCurrency, wait } from "@/util.js";
import CloseDialogButton from "@/components/UI/CloseDialogButton.vue";

export default {
  name: "MinimumOrderAmountDialog",
  components: { CloseDialogButton },
  computed: {
    ...mapState({
      cartDrawer: (state) => state.cart.dialogs.drawer,
      dialog: (state) => state.orders.dialog.minimumOrderAmount,
      storeInfo: (state) => state.store.info,
    }),
  },
  methods: {
    formatCurrency,
    wait,
  },
};
</script>

<style scoped>
.mdi-card-account-details-outline {
  font-size: 100px;
}
</style>
